module.exports = __webpack_public_path__ + "static/media/account.5afe9a87.svg";